import {useContext} from "react";

import {UserContext} from "./UserContext";
import {UserContextType} from "./interfaces";

export default function useUser(): UserContextType {
  return useContext(UserContext);
}
